import { defineComponent, PropType } from 'vue';
import { useI18n } from 'vue-i18n';
import { RelativeTimeVue } from '@/common/primary/relative-time';
import { ExclusiveImageVue } from '@/common/primary/fairplayer-image/exclusive-image';
import { FanImageVue } from '@/common/primary/fairplayer-image/fan-image';
import { BidWithExclusiveUi } from '@/staff/primary/auction/auction-details/BidWithExclusive.ui';

export default defineComponent({
  name: 'AuctionBidRow',

  props: {
    bid: {
      type: Object as PropType<BidWithExclusiveUi>,
      required: true,
    },
    index: {
      type: Number as PropType<number>,
      required: true,
    },
  },

  components: { RelativeTimeVue, ExclusiveImageVue, FanImageVue },

  setup() {
    const { t } = useI18n();

    return {
      t,
    };
  },
});
